import React from "react";
import { components } from "react-select";
import { TerritoryIcons } from "../../../Utils/Constants";

export default function SingleValue({ children, data, ...props }) {
  return (
    <components.SingleValue {...props}>
      <div className="territory-selected-value">
        <img src={TerritoryIcons[data.value]} alt="type" />
        {data.label}
      </div>
    </components.SingleValue>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Brand/components/SingleValue.js